module.exports = __webpack_public_path__ + "img/star-clicked.b4c02064.svg";